import { render, staticRenderFns } from "./registerStep1.vue?vue&type=template&id=a03c9870&scoped=true"
import script from "./registerStep1.vue?vue&type=script&lang=js"
export * from "./registerStep1.vue?vue&type=script&lang=js"
import style0 from "./registerStep1.vue?vue&type=style&index=0&id=a03c9870&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a03c9870",
  null
  
)

export default component.exports